import { UseSpringProps } from 'react-spring'

export const pageEntranceSpringValues: UseSpringProps = {
  onStart: () => {
    window.scrollTo(0, 0)
  },
  from: { height: '100%', width: '100%', opacity: 0, transform: `translateY(20px)` },
  to: { height: '100%', width: '100%', opacity: 1, transform: `translateY(0px)` },
}
